// extracted by mini-css-extract-plugin
module.exports = {"humidity":"Humidity_humidity__1JTrl","percentage":"Humidity_percentage__22lXd","percentageSign":"Humidity_percentageSign__1Xz3o"};